export const NAME = 'staging';

export const UPDATE_STAGING_BASIC = 'UPDATE_STAGING_BASIC';



// WEBPACK FOOTER //
// ./src/services/authentication/staging/constants.js